module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_disconnect-c3b6d1aa50815d465a4245684f4e90f0.svg";